export enum PanelSectionTypeEnum {
  PetDetails,
  PetWeight,
  PetDiagnosis,
  PetNutritionalAssessment,
}
